import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Quote } from 'lucide-react';
import { aboutData } from '../utils/mockData';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.645, 0.045, 0.355, 1],
      },
    },
  };

  return (
    <section className="about-section" id="about">
      <div className="section-container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="about-content"
        >

          {/* Section Title */}
          <motion.h2 variants={itemVariants} className="section-title">
            About
          </motion.h2>

          {/* Intro Paragraph */}
          <motion.p variants={itemVariants} className="about-intro">
            {aboutData.intro}
          </motion.p>

          {/* Quote Block */}
          <motion.div variants={itemVariants} className="about-quote-block">
            <Quote className="quote-icon" size={32} />
            <p className="quote-text">{aboutData.quote}</p>
          </motion.div>

          {/* How I Work */}
          <motion.div variants={itemVariants} className="about-work-section">
            <h3 className="subsection-title">How I work</h3>
            <ul className="work-list">
              {aboutData.approach.map((item, index) => (
                <motion.li
                  key={index}
                  variants={itemVariants}
                  className="work-item"
                >
                  <span className="work-bullet"></span>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Current Direction */}
          <motion.div variants={itemVariants} className="about-direction">
            <h3 className="subsection-title">Current direction</h3>
            <p className="direction-text">{aboutData.currentDirection}</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
